import { Component, ElementRef, HostListener, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { Router } from '@angular/router';
import { LanguageService, SiteLang } from '../../../services/language.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavbarComponent implements OnInit {

    @ViewChild('navpafar') navpafar: ElementRef<HTMLDivElement>;
    @ViewChild('servicesDropdownRef') servicesDropdownRef: ElementRef<HTMLElement>;
    @ViewChild('servicesDropdownRefResponsive') servicesDropdownRefResponsive: ElementRef<HTMLElement>;
    @ViewChild('langDropdownRef') langDropdownRef: ElementRef<HTMLElement>;

    displayLogo: boolean = false;
    langDropdownOpen = false;

    get currentFlagSrc(): string {
        return `assets/images/flags/${this.languageService.currentLang()}.svg`;
    }

    constructor(
        private viewportScroller: ViewportScroller,
        private router: Router,
        readonly languageService: LanguageService
    ) {}

    /** Mismo comportamiento que Home: ir al inicio y desplazar arriba (también si ya estás en /). */
    goHome(event: MouseEvent): void {
        event.preventDefault();
        if (this.classApplied) {
            this.toggleClass();
        }
        this.router.navigate(['/']).then(() => {
            requestAnimationFrame(() => this.viewportScroller.scrollToAnchor('home'));
        });
    }

    public onClick(elementId: string): void { 
        this.viewportScroller.scrollToAnchor(elementId);
    }

    ngOnInit() {
    }

    classApplied = false;
    servicesDropdownOpen = false;

    toggleClass() {
        this.classApplied = !this.classApplied;
        this.servicesDropdownOpen = false;
        this.langDropdownOpen = false;
    }

    toggleServicesDropdown(): void {
        this.servicesDropdownOpen = !this.servicesDropdownOpen;
        this.langDropdownOpen = false;
    }

    closeServicesDropdown(): void {
        this.servicesDropdownOpen = false;
    }

    toggleLangDropdown(event: MouseEvent): void {
        event.stopPropagation();
        this.langDropdownOpen = !this.langDropdownOpen;
        this.servicesDropdownOpen = false;
    }

    closeLangDropdown(): void {
        this.langDropdownOpen = false;
    }

    selectLanguage(lang: SiteLang): void {
        this.languageService.setLanguage(lang);
        this.closeLangDropdown();
    }

    /** Altura reservada para el navbar fijo (debe coincidir con scroll-margin-top) */
    private readonly scrollOffset = 90;

    goToServiceSection(anchor: string): void {
        this.closeServicesDropdown();
        const el = document.getElementById(anchor);
        if (el) {
            const y = el.getBoundingClientRect().top + this.viewportScroller.getScrollPosition()[1] - this.scrollOffset;
            this.viewportScroller.scrollToPosition([0, Math.max(0, y)]);
        } else {
            this.viewportScroller.scrollToAnchor(anchor);
        }
    }


    @HostListener('window:scroll', ['$event'])
    changeLogo(event: any): void {
        if (window.scrollY > 0) {
            this.displayLogo = true;
        } else {
            this.displayLogo = false;
        }
        this.closeServicesDropdown();
        this.closeLangDropdown();
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        const target = event.target as Node;
        const inDesktop = this.servicesDropdownRef?.nativeElement?.contains(target);
        const inResponsive = this.servicesDropdownRefResponsive?.nativeElement?.contains(target);
        if (!inDesktop && !inResponsive) {
            this.closeServicesDropdown();
        }
        if (!this.langDropdownRef?.nativeElement?.contains(target)) {
            this.closeLangDropdown();
        }
    }

    

}